import { DATE_TIME_FORMAT } from '@shared/utils'
import { DatePicker, Form } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const DateTimeElement = ({ element, required }: Props) => {
  return (
    <Form.Item name={element.name} label={element.label} rules={[{ required }]}>
      <DatePicker className="w-full" showTime format={DATE_TIME_FORMAT} />
    </Form.Item>
  )
}
